import { render, staticRenderFns } from "./BookASeatDialog.vue?vue&type=template&id=2d784377&scoped=true"
import script from "./BookASeatDialog.vue?vue&type=script&lang=js"
export * from "./BookASeatDialog.vue?vue&type=script&lang=js"
import style0 from "./BookASeatDialog.vue?vue&type=style&index=0&id=2d784377&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d784377",
  null
  
)

export default component.exports